import type { IDropDownItem, IDropdownProps } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";
import type { ForwardedRef } from "react";
import { forwardRef, memo } from "react";

const BaseMultiselectDropdown = <Type, Ref>(props: IDropdownProps<Type>, ref: ForwardedRef<Ref>) => {
    const { children, ...dropdownProps } = props;

    return (
        <Dropdown
            // @ts-expect-error Wrong type
            ref={ref}
            closeOnItemClick={false}
            {...dropdownProps}
        >
            {children as IDropDownItem[]}
        </Dropdown>
    );
};

export default memo(forwardRef(BaseMultiselectDropdown));
